import * as React from "react";
import {
  Text,
  View,
  StyleSheet,
  Image,
  Dimensions,
  TextInput,
  TouchableHighlight,
  FlatList,
  TouchableOpacity,
  Platform,
  useWindowDimensions
} from "react-native";
import { useSelector } from "react-redux";
import { Ionicons } from "@expo/vector-icons";
import { webGetOnlineOffers, resetOnlineOffers, webLoadOfferCategories } from "../../redux/actions/OfferActions";
import GlobalStyles from "../../components/GlobalStyles";
import StatusBar from "../../components/headers/StatusBar";
import { useNavigation } from "@react-navigation/native";
import Colors from "../../utilities/Color.js";
import ToggleOnline from "../../components/ToggleOnline";
import { Shadow } from "react-native-shadow-2";

function CategoryButton(element, onChangeSelectedCategory) {
  return (
    <View style={styles.buttonStyle}>
      <TouchableHighlight onClick={() => onChangeSelectedCategory(element.id)}>
        <Text>{element.name}</Text>
      </TouchableHighlight>
    </View>
  );
}
function ListItemNarrow({ offer, navigation }) {
  return (
    <View style={styles.listPaddingContainer}>
      <Shadow
        distance={5}
        startColor={Colors.LIGHTGRAY}
        endColor={Colors.WHITE}
        offset={[0, 0]}
        style={styles.shadowcorners}
      >
        <View
          style={[
            styles.listRowContainer,
            {
              width: 160,
              height: 250,
            },
          ]}
        >
          <TouchableOpacity
            style={[
              {
                backgroundColor: "#ffffff",
                borderBottomWidth: 0,
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                borderBottomLeftRadius: 5,
                backgroundColor: Colors.WHITE,
              },
            ]}
            activeOpacity={0.5}
            onPress={() =>
              navigation.navigate("WebOnlineOfferDetails", { offer: offer })
            }
          >
            <View
              style={{
                flex: 1,
                flexDirection: "column",
                width: 160,
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                borderBottomLeftRadius: 5,
                backgroundColor: Colors.WHITE,
              }}
            >
              <View style={styles.tileImageCotainer}>
                <Image
                  style={[styles.bigImageThumbnail, { height: 110 }]}
                  source={{ uri: offer.coverArt }}
                />
              </View>
              <View style={styles.tileBottomCotainer}>
                <View style={styles.rowLeftContainer}>
                  <Image
                    style={styles.iconThumbnail}
                    source={{ uri: offer.logo }}
                    resizeMode="contain"
                  />
                  <View
                    style={{ width: 90, alignSelf: "center", marginLeft: 5 }}
                  >
                    <Text style={styles.itemText}>{offer.advertiser}</Text>
                  </View>
                </View>
                <View
                  style={{ marginLeft: 8, marginBottom: 15, marginTop: 15 }}
                >
                  <Text style={styles.itemSubText}>{offer.title}</Text>
                </View>
              </View>
            </View>
          </TouchableOpacity>
        </View>
      </Shadow>
    </View>
  );
}
function ListItemWide({ offer, navigation }) {
  return (
    <View style={styles.listPaddingContainer}>
      <Shadow
        distance={5}
        startColor={Colors.LIGHTGRAY}
        endColor={Colors.WHITE}
        offset={[0, 0]}
        style={styles.shadowcorners}
      >
        <View
          style={[
            styles.listRowContainer,
            {
              width: 198,
              height: 380,
            },
          ]}
        >
          <TouchableOpacity
            style={[
              {
                backgroundColor: "#ffffff",
                borderBottomWidth: 0,
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                borderBottomLeftRadius: 5,
                backgroundColor: Colors.WHITE,
              },
            ]}
            activeOpacity={0.5}
            onPress={() =>
              navigation.navigate("WebOnlineOfferDetails", { offer: offer })
            }
          >
            <View
              style={{
                flex: 1,
                flexDirection: "column",
                width: 198,
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                borderBottomLeftRadius: 5,
                backgroundColor: Colors.WHITE,
              }}
            >
              <View style={styles.tileImageCotainer}>
                <Image
                  style={[styles.bigImageThumbnail, { height: 240 }]}
                  source={{ uri: offer.coverArt }}
                />
              </View>
              <View style={styles.tileBottomCotainer}>
                <View style={styles.rowLeftContainer}>
                  <Image
                    style={styles.iconThumbnail}
                    source={{ uri: offer.logo }}
                    resizeMode="contain"
                  />
                  <View
                    style={{ width: 100, alignSelf: "center", marginLeft: 5 }}
                  >
                    <Text style={styles.itemText}>{offer.advertiser}</Text>
                  </View>
                </View>
                <View
                  style={{ marginLeft: 8, marginBottom: 15, marginTop: 15 }}
                >
                  <Text style={styles.itemSubText}>{offer.title}</Text>
                </View>
              </View>
            </View>
          </TouchableOpacity>
        </View>
      </Shadow>
    </View>
  );
}
export default function WebBuyOnlineScreen() {
  var searchbox = React.createRef();
  const navigation = useNavigation();
  const [searchQuery, onChangeSearchText] = React.useState("");
  const [searchPending, onChangePendingSearchText] = React.useState("");
  const [searchCategory, onChangeSelectedCategory] = React.useState("");
  const loadingIcon = require("../../assets/res/Loading_Screen_blue.gif");

  const partners = useSelector((state) => state.partners.partners);
  const partnersLoaded = false;
  const onlineLoadedPage = useSelector((state) => state.offers.onlineLoadedPage);
  const onlineOffers = useSelector((state) => state.offers.onlineOffers);

  const offerCategories = useSelector((state) => state.offers.offerCategories);
  const categoriesLoaded = useSelector((state) => state.offers.categoriesLoaded);

  const favouriteOffers = useSelector((state) => state.offers.favouriteOffers);
  const favouriteOffersLoaded = useSelector((state) => state.offers.favouriteOffersLoaded);

  const [listMomentum, setMomentum] = React.useState(false);

  const { width } = useWindowDimensions();
  const blockPadding = 50;
  const stylesItemWidth = 198;
  const stylesItemMargin = 1;
  const minCols = 1;
  const calcNumColumns = (width) => {
    const cols = (width - blockPadding) / stylesItemWidth;
    const colsFloor = Math.floor(cols) > minCols ? Math.floor(cols) : minCols;
    const colsMinusMargin = cols - 2 * colsFloor * stylesItemMargin;
    if (colsMinusMargin < colsFloor && colsFloor > minCols) return colsFloor - 1;
    else return colsFloor;
  };
  const [numColumns, setNumColumns] = React.useState(calcNumColumns(width));

  React.useEffect(() => {
    setNumColumns(calcNumColumns(width));
  }, [width]);


  const hasCharity = 1;
  //const hasCharity = useSelector((state) => state.user.userData.subscriberDetails.charityId) != undefined;
  const [charityNag, setNag] = React.useState(false);
  React.useEffect(() => {
    if (!hasCharity && !charityNag) {
      setNag(true);
      navigation.navigate("NoCharityNotifaction");
    }
    if (onlineLoadedPage === 0) {
      webGetOnlineOffers(searchCategory, searchQuery);
    }
    if (!categoriesLoaded) {
      webLoadOfferCategories();
    }
  })

  return (
    <View style={GlobalStyles.containerMB}>
      {onlineLoadedPage === 0 ? (
        <View style={styles.LoadingContainer}>
          <Image style={styles.loadingImage} source={loadingIcon} />
        </View>
      ) : (
        <>
          {win.width > 768 ? (
            <View style={GlobalStyles.fullHeaderBarY}>
               <View style={{ height: 100}}/>
              {/* <MenuBar data="1" /> */}
              <View style={GlobalStyles.topHeaderTitelContainerForWeb}>
                <View style={[GlobalStyles.headerContainerKLYellow, { alignSelf: "center" }]}>
                  <View style={GlobalStyles.headerTextYellowForweb}>
                    <View>
                      <Text style={GlobalStyles.headingStyle}>Stores and offers</Text>
                      <Text style={GlobalStyles.subheaderStyleWeb}>Discover and select your partners</Text>
                    </View>
                    <View style={[GlobalStyles.backIconContainerForWeb, { marginLeft: 0 }]} >
                      <View style={GlobalStyles.toggleContainerForWeb}>
                        <ToggleOnline isWeb={true}/>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          ) : (
            <View>
              <StatusBar data="B_OL" />
            </View>
          )}
          {/* added for filter section */}
          <View style={styles.bodyContainerFilter}>
            <View style={styles.optionIconContainer}>
              <TouchableOpacity
                style={styles.closeButtonParent}
                onPress={() => { onChangeSearchText(searchPending); resetOnlineOffers(); }}
              >
                <Ionicons
                  name={"md-search"}
                  size={20}
                  color="#998fa2"
                  style={styles.iconStyle}
                />
              </TouchableOpacity>
              <TextInput
                onChangeText={(v) => onChangePendingSearchText(v)}
                placeholder="Search stores or products …"
                onSubmitEditing={() => { onChangeSearchText(searchPending); resetOnlineOffers(); }}
                defaultValue={searchQuery}
                style={styles.textInput}
                ref={(el) => (searchbox = el)}
              />
              <TouchableOpacity
                style={styles.closeButtonParent}
                onPress={() => { onChangeSearchText(""); onChangePendingSearchText(""); searchbox.clear(); resetOnlineOffers(); }}
              >
                <Ionicons
                  name={"md-close"}
                  size={20}
                  color="#998fa2"
                  style={styles.iconStyle}
                />
              </TouchableOpacity>
            </View>
            <Text style={styles.categoryHeader}>FILTER BY CATEGORY</Text>
            <View style={styles.buttonContainer}>
              <FlatList
                horizontal
                data={offerCategories}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={styles.catListStyle}
                renderItem={({ item }) => (
                  <TouchableOpacity
                    style={
                      item.id === searchCategory
                        ? styles.enabledButton
                        : styles.categoryButton
                    }
                    onPress={() => {
                      if (searchCategory === item.id) {
                        onChangeSelectedCategory("");
                      } else {
                        onChangeSelectedCategory(item.id);
                      }
                      resetOnlineOffers();
                    }}
                  >
                    <View>
                      <Text>{item.name}</Text>
                    </View>
                  </TouchableOpacity>
                )}
              />
            </View>
          </View>
          {/* <View style={win.width > 768 ? GlobalStyles.webBodyContainer : styles.bodyContainer  }> */}
          {/* <View style={styles.favListBox}>
            <Text style={styles.FavText}>MY ONLINE FAVOURITES</Text>
            <FlatList
              horizontal
              data={favouriteOffers.filter(rec => rec.isOnline === true)}
              // .filter(offer => {
              //   let i = favouriteOffers.filter(rec => rec.isOnline === true).findIndex(rec => rec.offerId === offer.id);
              //   if (i != -1) {
              //     return true;
              //   } else return false;
              // })}
              renderItem={({ item }) => (
                //onlineOffers.find(el => {return el.id == item.offerId}) != undefined ? 
                true ?
                  <TouchableOpacity
                    onPress={() =>
                      // navigation.navigate("OnlineOfferDetails", { offer: onlineOffers.find(el => {return el.id == item.offerId}) })
                      navigation.navigate("WebOnlineOfferDetails", { offerId: item.offerId })
                    }
                  >
                    <View style={styles.FavButton}>
                      <Image
                        style={styles.imageThumbnailSmall}
                        source={{ uri: item.logoUrl }}
                        resizeMode="contain"
                      />
                    </View>
                  </TouchableOpacity>
                  : <></>
              )}
            />
          </View> */}
          <View style={styles.bodyContainer}>
            <View style={platfrom === "web" ? styles.partnerListBox : GlobalStyles.partnerListBoxApp}>
              <View style={{ marginTop: 10 }}>
                {win.width > 768 ? (<FlatList
                  data={onlineOffers}
                  key={numColumns}
                  numColumns={numColumns}
                  keyExtractor={(i) => i.id}
                  initialNumToRender={5}
                  onEndReached={(dist) => {
                    webGetOnlineOffers(searchCategory, searchQuery)
                    // }
                  }}
                  onEndReachedThreshold={0.5}
                  renderItem={({ item }) => <ListItemWide offer={item} navigation={navigation} />}
                />) :
                  <FlatList
                    key={2}
                    data={onlineOffers}
                    numColumns={2}
                    keyExtractor={(i) => i.id}
                    initialNumToRender={5}
                    onEndReached={(dist) => {
                      webGetOnlineOffers(searchCategory, searchQuery)
                      // }
                    }}
                    onEndReachedThreshold={0.5}
                    renderItem={({ item }) => <ListItemNarrow offer={item} navigation={navigation} />}
                  />}
              </View>
              { /*
              <TouchableOpacity
                style={styles.closeButtonParent}
                onPress={() => { getOnlineOffers(searchCategory, searchQuery);}}
              >
                <Text>Load More</Text>
              </TouchableOpacity>
                */ }
            </View>
          </View>
          <View style={GlobalStyles.webFooter}>
            {/* {win.width > 768 ? <FooterBarWide /> : null} */}
          </View>
        </>
      )}
    </View>
  );
}

const platfrom = Platform.OS;
var ButmarginBottom, listWrap, butjustifyContent, containerWidth, alignType;
if (platfrom === "web") {
  ButmarginBottom = 10;
  listWrap = "wrap";
  butjustifyContent = "center";
  containerWidth = "100%";
  alignType = "alignItems";
} else {
  ButmarginBottom = 0;
  listWrap = "nowrap";
  butjustifyContent = "flex-start";
  containerWidth = null;
  alignType = "justifyContent";
}

const win = Dimensions.get("window");
var paddingLeft, paddingRight, mybackgroundColor;
const width = win.width;
if (width < 768) {
  paddingLeft = 15;
  paddingRight = 15;
  mybackgroundColor = "red";
} else if (768 < width && width < 880) {
  paddingLeft = 80;
  paddingRight = 80;
  mybackgroundColor = "green";
} else if (width > 880) {
  paddingLeft = 80;
  paddingRight = 80;
  mybackgroundColor = "yellow";
}

const styles = StyleSheet.create({
  LoadingContainer: {
    height: "100%",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  loadingImage: {
    height: 50,
    width: 50,
  },

  FavButton: {
    paddingLeft: 10,
    paddingRight: 10,
    overflow: "hidden",
    maxWidth: 65,
    paddingBottom: 10,
    minHeight: 65,
    marginRight: 10,
  },

  favListBox: {
    paddingTop: 10,
    paddingBottom: 0,
    backgroundColor: "#D2EEFB",
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    alignItems: "flex-start",
  },
  FavText: {
    color: Colors.DARKGRAY,
    alignSelf: "flex-start",
    paddingBottom: 10,
    fontFamily: "montserrat-medium",
    fontSize: 10,
  },
  FavItemText: {
    alignSelf: "center",
    maxHeight: 12,
    overflow: "hidden",
    fontFamily: "montserrat-regular",
    fontSize: 8,
    paddingTop: 0,
  },
  catListStyle: {
    flexWrap: listWrap,
    width: containerWidth,
    flexDirection: "row",
    alignType: butjustifyContent,
  },
  imageThumbnail: {
    // flex: 1,
    height: 62,
    width: 62,
    //resizeMode: "contain",
    margin: 1,
  },
  imageThumbnailSmall: {
    // flex: 1,
    height: 50,
    width: 50,
    //resizeMode: "contain",
    margin: 1,
  },

  categoryScroll: {
    marginBottom: 10,
    paddingBottom: 10,
  },
  categoryHeader: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    textAlign: "center",
    marginBottom: 15,
    lineHeight: 20,
    marginTop: 10,
    color: "#ffffff",
  },
  categoryButton: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "center",
    borderRadius: 30,
    // marginBottom: 5,
    lineHeight: 16,
    backgroundColor: "#ffffff",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: ButmarginBottom,
  },

  enabledButton: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "center",
    borderRadius: 30,
    // marginBottom: 5,
    lineHeight: 16,
    backgroundColor: "#FFC72C",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: ButmarginBottom,
  },
  bodyContainerFilter: {
    paddingTop: 20,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 10,
  },
  bodyContainer: {
    flex: 1,
    //paddingTop: 20,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    //paddingBottom: 30,
    backgroundColor: "#ffffff",
  },
  partnerListBox: {
    borderRadius: 20,
    paddingBottom: 15,
    alignItems: "center",
  },
  partnerListBoxApp: {
    borderRadius: 20,
    paddingBottom: 15,
  },
  buttonStyle: {
    width: 100,
    backgroundColor: "blue",
  },
  buttonContainer: {
    //width: 300,
    //height: 40,
    //flex: 1,
    //flexDirection: "row",
    // flexWrap: "wrap",
    //paddingLeft: 15,
    //paddingRight: 15,
    paddingBottom: 10,
  },
  textInput: {
    ...Platform.select({
      web: {
        outlineStyle: "none",
      },
    }),
    padding: 10,
    paddingRight: 20,
    paddingLeft: 20,
    height: 40,
    fontSize: 15,
    fontFamily: "montserrat-regular",
    flex: 1,
  },
  optionIconContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderColor: "#DDDDDD",
    borderBottomStartRadius: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    borderBottomRightRadius: 25,
    borderWidth: 1,
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 10,
    backgroundColor: "#ffffff",
    maxWidth: 600,
    alignSelf: "center",
  },
  iconStyle: {
    alignContent: "center",
    paddingRight: 20,
    paddingLeft: 10,
  },
  listRowContainer: {
    // flex: 1,
    flexDirection: "row",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    backgroundColor: Colors.WHITE,
  },
  rowLeftContainer: {
    flex: 1,
    flexDirection: "row",
    alignSelf: "flex-start",
    marginLeft: 8,
    marginTop: 8
  },
  rowRightContainer: {
    flex: 3,
    alignSelf: "center",
  },
  itemText: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    color: Colors.DARKGRAY,
    paddingBottom: 0
  },
  itemSubText: {
    fontFamily: "montserrat-bold",
    fontSize: 16,
    color: Colors.MIDBLUE
  },
  bigImageThumbnail: {
    width: "100%",
    resizeMode: "cover",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  tileBottomCotainer: {
    flex: 1,
    borderBottomWidth: 1,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: Colors.WHITE
  },
  iconThumbnail: {
    height: 55,
    width: 55
  },
  listPaddingContainer: {
    marginTop: 10,
    marginBottom: 10,
    marginRight: 10,
    marginLeft: 10,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    backgroundColor: Colors.WHITE,
  },
  shadowcorners: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    backgroundColor: Colors.WHITE,
  },
  listRowContainerPadded: {
    // flex: 1,
    flexDirection: "row",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    marginTop: 10,
    marginBottom: 10,
    marginRight: 10,
    marginLeft: 10,
    borderColor: Colors.WHITE
  },
});
